export default __webpack_public_path__ + "static/media/img-0205-columbia-premium-face.ee8e1934.png";